import FilterHelper from './FilterHelper';

type Operators = 'equals' | 'contains' | 'startsWith' | 'endsWith' | 'notEquals'

class StringFilterHelper extends FilterHelper {
  value = '';

  operator: Operators = 'equals';

  constructor(val: string, operator: Operators = 'equals') {
    super();
    this.value = val;
    this.operator = operator;
  }

  // eslint-disable-next-line class-methods-use-this
  getResult(): string {
    switch (this.operator) {
      case 'contains':
        return `%25${this.value}%25`;
      case 'endsWith':
        return `%25${this.value}`;
      case 'startsWith':
        return `${this.value}%25`;
      case 'notEquals':
        return `!${this.value}`;
      default:
        return this.value;
    }
  }
}

export const startsWith = (val: string) => new StringFilterHelper(val, 'startsWith');

export const endsWith = (val: string) => new StringFilterHelper(val, 'endsWith');

export const contains = (val: string) => new StringFilterHelper(val, 'contains');

export const notEquals = (val: string) => new StringFilterHelper(val, 'notEquals');

export const equals = (val: string) => new StringFilterHelper(val, 'equals');
